import React, { useState, useEffect, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

export const TextEditor = ({
  text,
  titulo,
  cuerpo,
  autos,
  handleTextChange
}: {
  text: string;
  titulo: string;
  cuerpo: string;
  autos: string;
  handleTextChange: (newValue: string) => void;
}) => {
  const [value, setValue] = useState('');
  const editorRef = useRef<{ getContent: () => string } | null>(null);

// Leemos la API Key a la manera de Create React App (Webpack)
  const tinyMceApiKey = process.env.REACT_APP_TINYMCE_APIKEY || '';

  useEffect(() => {
    if (text) {
        setValue(text);
        return;
    }

    const initialHtmlContent = `
      <p style="font-weight: bold;">${titulo}</p>
      <p>SR JUEZ:</p>
      <p>Dr. CRISTIAN ANDRES PARKES, abogado inscripto al Tº 115 F° 831 CPACF, CUIT 20-29006501-2, IVA Responsable Inscripto, en mi carácter de Letrado apoderado de la parte Actora, en los autos ${autos} a VS, respetuosamente digo: </p>
      <p style="text-align: justify; text-indent: 30px;">${cuerpo}</p>
      <p style="text-indent: 30px;">PROVEER DE CONFORMIDAD</p>
      <p style="text-indent: 30px;">SERA JUSTICIA</p>
    `;

    setValue(initialHtmlContent);
  }, [titulo, cuerpo, autos, text]);

  const handleEditorChange = (content: string) => {
    setValue(content);
    handleTextChange(content);
  };

  const printContent = () => {
    if (editorRef.current) {
      const content = editorRef.current.getContent();
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Impresión de Escrito</title>
              <style>
                body { font-family: 'Times New Roman', Times, serif; padding: 80px 20px 20px 80px; font-size: 14pt; line-height: 1.5; }
                p { margin: 0 0 10px 0; }
              </style>
            </head>
            <body>
              ${content}
            </body>
          </html>
        `);
        printWindow.document.close();
        setTimeout(() => {
            printWindow.print();
        }, 250);
      }
    }
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Editor
        apiKey={tinyMceApiKey}
        onInit={(evt, editor) => editorRef.current = editor}
        value={value}
        onEditorChange={handleEditorChange}
        init={{
          height: 400,
          menubar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
          ],
          toolbar: 'undo redo | blocks | ' +
            'bold italic underline strikethrough | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
          content_style: 'body { font-family: "Times New Roman",Times,serif; font-size: 14pt } p { margin: 0 }',
        }}
      />
      <div style={{ marginTop: '10px' }}>
        <button onClick={printContent} className="btn btn-primary btn-sm">
          Imprimir
        </button>
      </div>
    </div>
  );
};